export default __webpack_public_path__ + "static/media/View_1UP_Icon_Inactive.b46c36ea.svg";